<div class="login-page">
  <div class="login-container">

  <!-- Forgot Password Left Side Section Code Start -->      
    <div class="login-form-container forgot-password-container" role="main">
      <div class="logo"><img src="assets/images/logo.svg" alt="Logo" /></div>
      <h1 class="heading-level-4 gray-color mt-40 mb-20">Forgot Your Password?</h1>
      <p class="forgot-label">Enter your email address to receive a password reset link.</p>
  
      <form class="form-style1" #courseForm="ngForm" (ngSubmit)="ForgotPassword()">          
        <div class="form-group">
            <input type="email" id="email" name="email" placeholder=" " [(ngModel)]="email" required>
            <label for="email">Email</label>
            <img class="icon" src="assets/images/mail_icon.svg" alt="Mail" />
        </div>          
        <button type="submit" class="button-style1 width-135">Submit</button>

        <div *ngIf="erroremailMsg" role="alert" class="errormsg">
          {{erroremailMsg}}</div>

          
    </form>
    <div class="login-bottom-section" aria-label="contentinfo">
      <img src="assets/images/ABA-logo.png" alt="ABA Logo" aria-label="Footer Logo"/>
      <p>© {{ currentYearCopyRight }} American Bankers Association</p>        
    </div>
  </div>
  <!-- Forgot Password Left Side Section Code Start -->      

  <!-- Forgot Password Right Side Image Section Code Start -->      
  <div class="login-image-container" role="banner">
      <img src="assets/images/fp-banner.png" alt="Forgot Password" />
  </div>
  <!-- Forgot Password Right Side Image Section Code End -->      

</div>
</div>